export const STATUSES: Record<string, string> = {
  ASSIGNED: 'ASSIGNED',
  STARTED: 'STARTED',
  PATIENT_CARE: 'PATIENT_CARE',
};

export type FareStatusType = keyof typeof STATUSES;
